
import React from 'react';

const IDMContext = React.createContext({
    authProviderConfig: null,
    setAuthProviderConfig: () => {},
});

export default IDMContext;
